import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop component - Ensures all page navigations start at the top of the screen
 * This prevents React Router from remembering scroll positions between page changes
 */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll main window to top
    window.scrollTo(0, 0);
    
    // Also scroll any custom scrollable containers to top
    document.querySelectorAll('[data-scroll-container]').forEach((el) => {
      el.scrollTop = 0;
    });
  }, [pathname]);

  return null;
}
